<small><app-appversion></app-appversion>&nbsp;<app-connection></app-connection> </small>
<br/>


<div *ngIf="authEnabled; else loggedOut">
  <app-auth-button></app-auth-button>
    <div class="container" *ngIf="auth.isAuthenticated$ | async; ">

      <app-menu></app-menu>



      <div class="content">
        <router-outlet (activate)="onActivate()"></router-outlet>
      </div>
    </div>
</div>
<ng-template #loggedOut>
  <H1>Running without authorisation</H1>



    <app-menu></app-menu>
    <div class="content">
      <router-outlet (activate)="onActivate()"></router-outlet>
    </div>
</ng-template>


